import {
  RELATIONSHIP_TYPES,
  SEAT_PREFERENCES,
  type MeasurementSystem,
  type RelatedPassengerCreatePayload,
  type RelatedPassengerFormData,
} from '@/types/clientsApiTypes';
import { replaceDraftData } from '../replaceMockData';

export const getNewPassengerData = (passengerData: RelatedPassengerCreatePayload): RelatedPassengerFormData => {
  return {
    client: {
      client_id: passengerData.id ?? 0,
      userHasCertifiedTheInformation: false,
      preferred_name: null,
      first_name: replaceDraftData(passengerData.first_name || '') ?? '',
      middle_name: null,
      last_name: replaceDraftData(passengerData.last_name || '') ?? '',
      gender: '',
      relationship: RELATIONSHIP_TYPES.sibling,
      contact_primary_client_id: null,
      date_of_birth: passengerData.date_of_birth ?? '',
      email: passengerData.email ?? '',
      phone: passengerData.phone ?? '',
      client_mailing_address: '',
      client_mailing_address_line_2: '',
      client_mailing_city: '',
      client_mailing_state: '',
      client_mailing_country: '',
      additional_emails: [],
      phones: [],
      zip_code: '',
      same_as_primary: false,
    },
    tsa: {
      global_entry: null,
      global_expiry_date: null,
      known_traveler_number: null,
      known_traveler_number_expire_date: null,
    },
    passport: {
      passport_number: null,
      expiry_date: null,
      passport_id: null,
    },
    preference_data: {
      allergies: null,
      fly: {
        seat: SEAT_PREFERENCES.window,
        allergies: '',
        preferred_private_aviation_company: null,
        fly_private_aviation: 'no',
        class_preference: [],
      },
      personal: {
        personal_metric_system: 'us' as MeasurementSystem,
        comfort_related: {
          us: {
            height: '',
            weight: '',
          },
          metric: {
            height: '',
            weight: '',
          },
        },
        information: '',
      },
    },
    documents: [],
    loyalty_numbers: [],
  };
};
